import { OrganizationFull, User } from 'api/model'
import { atom, atomFamily } from 'recoil'

const adminOrgsAtom = atom<OrganizationFull[]>({
  key: 'adminOrgsList',
  default: [],
})

const membersByAdminOrgFamily = atomFamily<User[], string>({
  key: 'membersByAdminOrgs',
  default: [],
})

const organizationIdAtom = atom<string>({
  key: 'organizationIdAtom',
  default: '',
})

export { adminOrgsAtom, membersByAdminOrgFamily, organizationIdAtom }
